import CMS from "../routes/cms";
import CMSEvents from "../routes/cms/events";
import CMSEventPage from "../routes/cms/event_page";
import CMSStaffPage from "../routes/cms/staff_page";
import Teaching from "../routes/teaching";

import { claimKey } from "./claims";
import { RouteComponentProps } from "src/declaration";
import {
  ClassNightWithLocation,
  DanceEvent,
  DanceEventWithSchedule,
  ExternalEvent,
  URLArray,
} from "./door";
import { lazy } from "preact-iso";
import { JSX } from "preact";

const Admin = lazy(() => import("../routes/admin/routes"));
const Door = lazy(() => import("../routes/door"));
const DoorPublic = lazy(() => import("../routes/door/public"));
const Profile = lazy(() => import("../routes/profile"));
const StagePage = lazy(() => import("../routes/stage"));
const CMSMusicPage = lazy(() => import("../routes/cms/music"));

export const ComponentTypeNames = [
  "Profile",
  "CMS",
  "Teaching",
  "Door",
  "DoorPublic",
  "Admin",
  "CMSEvents",
  "CMSEventPage",
  "CMSStaffPage",
  "CMSMusicPage",
  "StagePage",
];

export type ComponentType = (arg0: RouteComponentProps) => JSX.Element;

export const Controllers: Record<string, ComponentType> = {
  DoorPublic,
  CMS,
  CMSEvents,
  CMSEventPage,
  CMSStaffPage,
  CMSMusicPage,
  Profile,
  Teaching,
  Door,
  Admin,
  StagePage,
};

export interface RouteEntryComponent {
  title: string;
  component: ComponentType;
}

export interface RouteEntrySub {
  title: string;
  subRoute: RouteSet;
}

export type RouteEntry = RouteEntryComponent | RouteEntrySub;
export type RouteSet = Record<string, RouteEntry>;

export interface pageEntry {
  id?: string;
  url?: string;
  component: keyof typeof Controllers;
  title: string;
  body?: string;
  menuOrder?: number;
  topLevelApp?: boolean;
  fullscreen?: boolean;
  role?: claimKey;
  data?: object;
}
export type pageList = Record<string, pageEntry>;

export interface PageDataTypeCMSEvent {
  body: string;
  CMSEvents: {
    internal?: DanceEvent[];
    external?: ExternalEvent[];
    past?: DanceEvent[];
  };
}

export interface PageDataTypeCMSEventPage {
  body: string;
  CMSEventPage: {
    eventList?: DanceEventWithSchedule[];
    eventId?: string;
  };
}

export interface PageDataTypeCMSStaffPage {
  body: string;
  CMSStaffPage: {
    staff: [{ name: string; photo?: string; blurb?: string; hidden?: boolean }];
  };
}

export interface PageDataTypeCMSMusicPage {
  body: string;
  CMSMusicPage: [
    {
      name: string;
      location?: string;
      when: ReturnType<typeof Date.now>;
      playlists?: URLArray;
    },
  ];
}

export interface PageDataTypeTeaching {
  Teaching: ClassNightWithLocation[];
}
